import { auth, sessionTimer, type User, useUserInfo } from '@netpurpose/api'
import { useEffect, useState } from 'react'

export const useLoggedIn = (): { user?: User | undefined } => {
  const [authReady, setAuthReady] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      await auth.authStateReady()
      setAuthReady(true)
    }
    checkAuth()
  }, [])

  const authUser = auth.currentUser
  const { data: user } = useUserInfo({ enabled: Boolean(authReady && authUser) })

  useEffect(() => {
    sessionTimer.startTimerForGroups(user?.groups)
  }, [user])

  if (!authUser) {
    return {}
  }

  return { user }
}
